//初心shop
exports.ApiHost = 'http://cxshop.wsc.tech';
exports.WsHost = "http://cxshop.wsc.tech/ws";
//公司测试服务器
exports.ApiHost = 'https://phvbpggecoaz.ap-northeast-1.clawcloudrun.com';
exports.WsHost = "https://phvbpggecoaz.ap-northeast-1.clawcloudrun.com/ws";
exports.ApiHost = 'http://rustred.test.wsc.tech:8080';
exports.WsHost = "http://rustred.test.wsc.tech:8080/ws";

//公司测试服务器CF通道	·
exports.ApiHost = 'https://dash.scrab.top';
exports.WsHost = "https://dash.scrab.top/ws";

// //爱飞之家	·
// exports.ApiHost = 'http://afzj.test.wsc.tech:8080';
// exports.WsHost = "http://afzj.test.wsc.tech:8080/ws";

//测试本地后台
//exports.ApiHost = 'http://localhost:8080';
//exports.WsHost = "ws://localhost:8080/ws";

exports.RoutePrefix = '';

exports.Version = "1.0.8";
